import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoginToken, reqData } from "../../../js/server";
import queryString from "query-string";
import SubMenu from "../../comm/SubMenu";
import List from "../../comm/List";
import Paging from "../../comm/Paging";
import { useHistory } from "react-router";
import SubBanner from "../../comm/SubBanner";
import {
    getServiceName,
    getSub01,
    getSub02,
    getSubHeader,
    fnNotLogin,
    fnNotOfficers,
    canWrite,
} from "../../../js/util";

function AdminBoardList({ match, location, history }) {
    const dispatch = useDispatch();
    const usehistory = useHistory();
    const query = queryString.parse(location.search);
    const [posts, setPosts] = useState({ items: [] });
    const [isPosts, setIsPosts] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    // eslint-disable-next-line
    const [postsPerPage, setPostsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [userToken, setUserToken] = useState(null);
    const [userType, setuserType] = useState(null);
    const [boardKind, setBoardKind] = useState(null); //게시판종류
    const keyword = query.keyword;
    const page = query.page;
    const kind = query.kind;

    const newClick = () => {
        const keyword = document.getElementById("inputKeyword").value;
        //검색 상태 Hash 저장
        window.document.location.hash =
            "#" + currentPage + "^" + encodeURI(keyword);
        usehistory.push(
            `/ABoardNew?kind=${boardKind}&page=${currentPage}&keyword=${encodeURI(
                keyword
            )}`
        );
    };

    async function fetchData(page = 1) {
        //Hash에 남길 State 저장
        setCurrentPage(Number(page));
        const jsonData = {
            servicename: `${getServiceName(boardKind)}List`,
            userToken: userToken,
            keyword: document.getElementById("inputKeyword").value,
            currentPage: page,
            maxListCount: postsPerPage,
        };

        reqData(jsonData)
            .then((res) => {
                console.log(res.data);

                if (res.data.result === "OK") {
                    console.log(res.data);
                    setTotalCount(res.data.totalCnt);
                    setPosts(res.data.jsonData);
                    setIsPosts(res.data.jsonData.length > 0);
                } else {
                    setTotalCount(0);
                    setPosts([]);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    }

    const fnSearchClick = () => {
        if (document.getElementById("inputKeyword").value.length > 1) {
            fetchData(1);
        } else {
            alert("검색어는 2자 이상 필요합니다.");
        }
    };

    const setPage = (page) => {
        fetchData(page);
    };

    const listClick = (key) => {
        const keyword = document.getElementById("inputKeyword").value;
        //검색 상태 Hash 저장
        window.document.location.hash =
            "#" + currentPage + "^" + encodeURI(keyword);
        usehistory.push(
            `/ABoardView?bserial=${key}&page=${currentPage}&keyword=${encodeURI(
                keyword
            )}&kind=${kind}`
        );
    };

    const fnBoardDelete = (bserial) => {
        if (
            window.confirm("게시글을 삭제 하시겠습니까?\n삭제후 복구가 불가능합니다.")
        ) {
            const jsonData = {
                servicename: `${getServiceName(kind)}Delete`,
                userToken: userToken,
                bserial: bserial,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        alert("삭제되었습니다.");
                        fetchData(currentPage);
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const initBoard = () => {
        let defaultPage = 1;

        //검색 상태 Hash 불러오기
        if (keyword || page) {
            defaultPage = page;
            document.getElementById("inputKeyword").value = keyword;
        } else if (window.document.location.hash) {
            let strHash = window.document.location.hash;
            let arrCur = null;

            strHash = strHash.replace("#", "");
            arrCur = strHash.split("^");
            if (arrCur.length === 2) {
                defaultPage = arrCur[0] ? arrCur[0] : 1;
                document.getElementById("inputKeyword").value = arrCur[1];
            }
        }

        fetchData(defaultPage);
    };

    useEffect(
        () => {
            if (kind) {
                dispatch({
                    type: "pageChange",
                    payload: { sub01: getSub01(kind), sub02: getSub02(kind) },
                });
                setTimeout(() => {
                    //로그인 체크
                    const userinfo = JSON.parse(localStorage.getItem("userinfo"));
                    if (userinfo) {
                        const userToken = userinfo.userToken;
                        setUserToken(userToken);
                        setBoardKind(kind);
                        //로그인 체크 후 Usertype 검사
                        LoginToken(userToken)
                            .then((res) => {
                                if (res.data.result === "OK") {
                                    //userType 저장
                                    setuserType(res.data.jsonData.usertype);

                                    //임원자료실은 임원 이상만 열람 가능
                                    if (
                                        boardKind === "pds05" &&
                                        Number(res.data.jsonData.usertype) > 2
                                    ) {
                                        fnNotOfficers();
                                    } else if (
                                        //조합 자료실은 조합직원 이상만 열람 가능
                                        boardKind === "pds08" &&
                                        Number(res.data.jsonData.usertype) > 1
                                    ) {
                                        fnNotOfficers();
                                    } else {
                                        initBoard();
                                    }
                                } else {
                                    fnNotLogin();
                                }
                            })
                            .catch((err) => {
                                console.error(err);

                                fnNotLogin();
                            })
                            .finally(() => { });
                    } else {
                        if (kind !== "free" && kind !== "joboffer") {
                            fnNotLogin();
                        } else {
                            setBoardKind(kind);

                            initBoard();
                        }
                    }
                }, 500);
            } else {
                usehistory.push("/");
            }
        },
        // eslint-disable-next-line
        [kind, boardKind, dispatch]
    );

    return (
        <>
            <SubBanner id={kind} />

            <section className="adminboard section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="row">{getSubHeader(boardKind)}</div>

                            <div className="row search-bar">
                                <div className="col-12">
                                    <div className="input-group mb-3 mt-3">
                                        <input
                                            type="text"
                                            id="inputKeyword"
                                            className="form-control board-keyword"
                                            placeholder="제목, 내용"
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") {
                                                    fnSearchClick();
                                                }
                                            }}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-custom-search"
                                                style={{ backgroundColor: "#4844ff" }}
                                                type="button"
                                                onClick={() => {
                                                    fnSearchClick();
                                                }}
                                            >
                                                <i className="icofont-search-2" />
                                            </button>
                                            <button
                                                className="btn btn-custom-init btn-board-search"
                                                type="button"
                                                onClick={() => {
                                                    document.getElementById("inputKeyword").value = "";

                                                    fetchData(1);
                                                }}
                                            >
                                                <i
                                                    className="icofont-eraser"
                                                    style={{ color: "#666666" }}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {canWrite(boardKind, userType) ? (
                                <div className="row pb-10">
                                    <div className="col-12">
                                        <button
                                            className="btn btn-light btn-custom-sm"
                                            type="button"
                                            onClick={newClick}
                                        >
                                            <i className="icofont-edit-alt"></i>&nbsp;신규
                                        </button>
                                    </div>
                                </div>
                            ) : null}

                            <div className="row">
                                <div className="table-responsive datatable-list">
                                    <List
                                        posts={posts}
                                        id={
                                            boardKind === "gallery"
                                                ? "Gallery"
                                                : boardKind === "news"
                                                    ? "News"
                                                    : boardKind === "laws"
                                                        ? "Laws"
                                                        : "Info"
                                        }
                                        listClick={listClick}
                                        isPosts={isPosts}
                                        userType={userType}
                                        fnBoardDelete={fnBoardDelete}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <Paging
                                        page={currentPage}
                                        count={totalCount}
                                        setPage={setPage}
                                    />
                                </div>
                            </div>
                        </div>

                        <SubMenu id={boardKind} />
                    </div>
                </div>
            </section>
        </>
    );
}

export default AdminBoardList;
